import { render, staticRenderFns } from "./ContactSidebarComponent.vue?vue&type=template&id=d55ad0da&scoped=true"
import script from "./ContactSidebarComponent.vue?vue&type=script&lang=js"
export * from "./ContactSidebarComponent.vue?vue&type=script&lang=js"
import style0 from "./ContactSidebarComponent.vue?vue&type=style&index=0&id=d55ad0da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d55ad0da",
  null
  
)

export default component.exports